<form id="form" [formGroup]="form" (ngSubmit)="submitForm()" *ngIf="form">
	<div class="row my-4">
		<div *ngIf="form.contains('firstName')" class="col-12 col-lg">
			<label for="firstName" class="form-label theme-main-color fw-bold"
				>Prénom</label
			>
			<input
				autocomplete="off"
				type="text"
				class="form-control"
				id="firstName"
				name="firstName"
				formControlName="firstName"
				[ngClass]="{
					'is-invalid': firstName.invalid,
					'is-valid': firstName.dirty && firstName.valid
				}"
			/>
			<div
				*ngIf="firstName.invalid && (firstName.dirty || firstName.touched)"
				class="invalid-feedback"
			>
				<span *ngIf="firstName.errors?.required">Un prénom est requis</span>
				<span *ngIf="firstName.errors?.maxlength"
					>Le prénom ne doit pas dépasser {{ MAX_NAME_CHAR }} caractères</span
				>
				<span *ngIf="firstName.errors?.pattern"
					>Le prénom doit être valide : pas de caractères spéciaux (accents
					autorisés)
				</span>
			</div>
		</div>
		<div *ngIf="form.contains('lastName')" class="col-12 col-lg">
			<label for="lastName" class="form-label theme-main-color fw-bold"
				>Nom</label
			>
			<input
				autocomplete="off"
				type="text"
				class="form-control"
				id="lastName"
				name="lastName"
				formControlName="lastName"
				[ngClass]="{
					'is-invalid': lastName.invalid,
					'is-valid': lastName.dirty && lastName.valid
				}"
			/>
			<div
				*ngIf="lastName.invalid && (lastName.dirty || lastName.touched)"
				class="invalid-feedback"
			>
				<span *ngIf="lastName.errors?.required">Un nom est requis</span>
				<span *ngIf="lastName.errors?.maxlength"
					>Le nom ne doit pas dépasser {{ MAX_NAME_CHAR }} caractères</span
				>
				<span *ngIf="lastName.errors?.pattern"
					>Le nom doit être valide : pas de caractères spéciaux (accents
					autorisés)
				</span>
			</div>
		</div>
	</div>

	<div class="row my-4">
		<!-- <div *ngIf="form.contains('birthDate')" class="col-12 col-lg">
			<label for="birthDate" class="form-label theme-main-color fw-bold"
				>Date de naissance</label
			>
			<input
				autocomplete="off"
				type="text"
				bsDatepicker
				class="form-control"
				id="birthDate"
				formControlName="birthDate"
			/>
		</div> -->
		<div *ngIf="form.contains('username')" class="col-12 col-lg">
			<label for="username" class="form-label theme-main-color fw-bold"
				>Nom d'utilisateur</label
			>
			<input
				autocomplete="off"
				type="text"
				class="form-control"
				id="username"
				name="username"
				formControlName="username"
				[ngClass]="{
					'is-invalid': username.invalid,
					'is-valid': username.dirty && username.valid
				}"
			/>
		</div>
	</div>

	<div class="row my-4">
		<!-- <div *ngIf="form.contains('address')" class="col-12 col-lg">
			<label for="address" class="form-label theme-main-color fw-bold"
				>Adresse</label
			>
			<input
				autocomplete="off"
				type="text"
				class="form-control"
				id="address"
				name="address"
				[typeahead]="addressList"
				[typeaheadAsync]="true"
				typeaheadOptionField="displayName"
				(typeaheadLoading)="changeTypeaheadLoading($event)"
				formControlName="address"
				(keyup)="selectedAddressKeyUp($event.target)"
				(typeaheadOnSelect)="onAddressSelect($event)"
				[ngClass]="{
					'is-invalid':
						address.invalid ||
						(address.dirty &&
							!(isAddressDefault.value || isAddressSelected.value)),
					'is-valid': address.dirty && address.valid && isAddressSelected.value
				}"
			/>
		</div> -->
		<div *ngIf="form.contains('phone')" class="col-12 col-lg">
			<label for="phone" class="form-label theme-main-color fw-bold"
				>Téléphone</label
			>
			<input
				autocomplete="off"
				type="text"
				class="form-control"
				id="phone"
				name="phone"
				formControlName="phone"
				[ngClass]="{
					'is-invalid': phone.invalid,
					'is-valid': phone.dirty && phone.valid
				}"
			/>
			<div *ngIf="phone.invalid" class="invalid-feedback">
				<span *ngIf="phone.errors?.pattern"
					>Veuillez saisir un numéro de téléphone correct : 0123456789</span
				>
			</div>
		</div>
	</div>

	<div *ngIf="form.contains('email')" class="row my-4">
		<div class="col-12 col-lg-6">
			<label for="email" class="form-label theme-main-color fw-bold"
				>Email</label
			>
			<input
				autocomplete="off"
				type="text"
				class="form-control"
				id="email"
				name="email"
				formControlName="email"
				[ngClass]="{
					'is-invalid': email.invalid,
					'is-valid': email.dirty && email.valid
				}"
			/>
		</div>
		<div class="col-12 col-lg-6">
			<label for="inputEmailConfirm" class="form-label theme-main-color fw-bold"
				>Confirmer l'email</label
			>
			<input
				autocomplete="off"
				type="text"
				class="form-control"
				id="inputEmailConfirm"
				name="emailConfirm"
				formControlName="email"
			/>
		</div>
	</div>

	<div class="row my-4">
		<div *ngIf="form.contains('profile')" class="col">
			<label for="profile" class="form-label theme-main-color fw-bold">Rôle
			</label>
			<select
				id="profile"
				class="form-select"
				name="profile"
				formControlName="profile"
				aria-label="Sélectionner un profil"
				>
				<option *ngFor="let profile of listProfile" value="{{ profile.id }}">
					{{ profile.name }}
				</option>
			</select>
		</div>
	</div>

	<div class="row my-4">
		<div class="col-12 col-lg">
			<label for="service" class="form-label fw-bold">Services</label>
			<div class="row">
				<div
					class="col-md-4 check"
					*ngFor="let service of listService | orderBy : 'name' : 'asc'"
				>
				<div *ngIf="service.id !== 0">
					<input
						type="checkbox"
						name="{{ service.id }}"
						class="form-check-input"
						[value]="service"
						[checked]="isServiceCheck(service)"
						[ngClass]="{
							'theme-main-color-check': isServiceCheck(service)
						}"
						(change)="updateSelectedService($event, service)"
					/>
					<label class="ms-2 form-check-label text-dark">
						{{ service.name }}
					</label>
				</div>
			</div>
			</div>
		</div>
	</div>

	<div class="row my-4" *ngIf="listRegion.length > 1">
		<div class="col-12 col-lg">
			<label for="region" class="form-label fw-bold">Regions</label>
			<div class="row">
				<div
					class="col-md-4 check"
					*ngFor="let region of listRegion | orderBy : 'name' : 'asc'"
				>
				<div *ngIf="region.id !== 0">
					<input
						type="checkbox"
						name="{{ region.id }}"
						class="form-check-input"
						[value]="region"
						[checked]="isRegionCheck(region)"
						[ngClass]="{
							'theme-main-color-check': isRegionCheck(region)
						}"
						(change)="updateSelectedRegion($event, region)"
					/>
					<label class="ms-2 form-check-label text-dark">
						{{ region.name }}
					</label>
				</div>
			</div>
			</div>
		</div>
	</div>

	<div class="row">
		<div
			*ngIf="form.contains('active')"
			class="form-check form-switch ms-2"
		>
			<input
				class="form-check-input theme-main-border-color"
				type="checkbox"
				id="active"
				formControlName="active"
				[ngClass]="{
					'theme-main-color-check': active.value
				}"
			/>
			<label class="form-check-label text-dark" for="active"
				>Actif</label
			>
		</div>
	</div>

	<div *ngIf="isAddForm" class="row my-5">
		<div class="d-flex justify-content-end">
			<button
				class="btn theme-main-color-button mx-3 px-3"
				type="button"
				(click)="hideModal.emit()"
			>
				Retour
			</button>
			<button
				[disabled]="
					!form.valid ||
					!(isAddressDefault.value || isAddressSelected.value) ||
					isValidateButtonClicked.value
				"
				class="btn theme-green-button"
				type="submit"
				form="form"
			>
				<i class="bi bi-save-fill px-1" aria-hidden="true"></i>Sauvegarder
			</button>
		</div>
	</div>
</form>
